import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import MDBox from "./MDBox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";

/**
 * MDHoverIconTooltip
 * Modern icon tooltip: shows an icon, and on hover displays a styled tooltip with all array values.
 */
function MDHoverIconTooltip({ icon = "info", values = [], tooltipTitle = "Details", color = "info" }) {
  const tooltipContent = (
    <MDBox sx={{ minWidth: 220, p: 2, bgcolor: '#f7faff', borderRadius: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: '#1976d2', fontSize: '1.1rem', letterSpacing: 0.2 }}>
        {tooltipTitle}
      </Typography>
      <List dense sx={{ p: 0 }}>
        {values && values.length > 0 ? (
          values.map((val, idx) => (
            <ListItem key={idx} sx={{ py: 0.5, px: 0 }}>
              <Typography variant="body1" sx={{ color: '#444', fontSize: '0.98rem', fontWeight: 500, letterSpacing: 0.1 }}>
                {val}
              </Typography>
            </ListItem>
          ))
        ) : (
          <ListItem>
            <Typography variant="body1" sx={{ color: '#888', fontSize: '0.98rem', fontWeight: 400 }}>
              No values
            </Typography>
          </ListItem>
        )}
      </List>
    </MDBox>
  );

  return (
    <Tooltip
      title={tooltipContent}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: '#fff',
            color: '#333',
            boxShadow: 4,
            borderRadius: 3,
            p: 0,
            maxWidth: 340,
            fontFamily: 'Roboto, Arial, sans-serif',
          },
        },
        arrow: {
          sx: {
            color: '#fff',
          },
        },
      }}
    >
      <MDBox display="inline-flex" alignItems="center" sx={{ cursor: "pointer" }}>
        <Icon color={color} sx={{ fontSize: '20px !important', transition: "color 0.2s", "&:hover": { color: "#1976d2" } }}>
          {icon}
        </Icon>
      </MDBox>
    </Tooltip>
  );
}

MDHoverIconTooltip.propTypes = {
  icon: PropTypes.string,
  values: PropTypes.array,
  tooltipTitle: PropTypes.string,
  color: PropTypes.string,
};

export default MDHoverIconTooltip;